/**
 * Verify that an optional value is properly defined (i.e. not `undefined` or `null`).
 * @param value Value to be verified
 * @throws Throws an error if `value` is `undefined` or `null`
 */
export function assertNonNullable<T>(value: T): asserts value is NonNullable<T> {
	if (value === undefined || value === null) {
		throw new Error(`Expected 'value' to be non-nullable but was '${value}'.`);
	}
}
